module.exports = __webpack_public_path__ + "static/aaron-11bb85a25909d513cd6d8e3117ae5ded.jpg";